import { AdresseJson } from './structure-dto.model';

export interface Structure {
  typeStructure?: string;
  idStructure?: string;
  cleContrat?: string;
  clePerimetreContractuel?: string;
  raisonSociale?: string;
  isLiberal: boolean;
  codeDepartement?: string;
  codeSecteurActivite?: string;
  libelleSecteurActivite?: string;
  adressePostale?: AdresseJson;
  typeEntite?: string;
}

export interface StructureSituation {
  codeFonction?: string;
  identifiantStructure?: string;
  typeStructure?: string;
}

/**
 * Enum to define structure tiers choices
 */
export enum StructureTiers {
  OUI = 'OUI',
  NON = 'NON',
  ATTENTE = 'ATTENTE',
}
